import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "h-screen p-4 overflow-y-auto flex justify-center" }
const _hoisted_2 = { class: "flex flex-col my-auto sm:align-middle max-w-7xl" }
const _hoisted_3 = { class: "bg-white" }
const _hoisted_4 = {
  key: 9,
  class: "p-10"
}
const _hoisted_5 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarSottoProgetto = _resolveComponent("ToolbarSottoProgetto")!
  const _component_ViewForm = _resolveComponent("ViewForm")!
  const _component_SottoProgettoForm = _resolveComponent("SottoProgettoForm")!
  const _component_FlagForm = _resolveComponent("FlagForm")!
  const _component_InfoPolicy = _resolveComponent("InfoPolicy")!
  const _component_Sconto = _resolveComponent("Sconto")!
  const _component_ImportaSottoprogetto = _resolveComponent("ImportaSottoprogetto")!
  const _component_EsportaSottoprogetto = _resolveComponent("EsportaSottoprogetto")!
  const _component_FeeRebateForm = _resolveComponent("FeeRebateForm")!
  const _component_CambioValutaForm = _resolveComponent("CambioValutaForm")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_ctx.visible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "fixed z-20 inset-0 drop-shadow-3xl transition-opacity bg-gray-500 bg-opacity-70",
        onKeydown: _cache[22] || (_cache[22] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ToolbarSottoProgetto, {
              id: _ctx.id,
              "onUpdate:tabindex": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:tabindex',$event))),
              class: "self-center",
              tabindex: _ctx.tabindex
            }, null, 8, ["id", "tabindex"]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.tabindex === 5)
                ? (_openBlock(), _createBlock(_component_ViewForm, {
                    key: 0,
                    onSave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('savePreference', $event))),
                    onChiudi: _ctx.chiudi,
                    class: "p-10 lg:px-20 lg:py-14"
                  }, null, 8, ["onChiudi"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 0)
                ? (_openBlock(), _createBlock(_component_SottoProgettoForm, {
                    key: 1,
                    onSaved: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('saved', $event))),
                    create: false,
                    onChiudi: _ctx.chiudi,
                    id: _ctx.id,
                    cliente_id: _ctx.cliente_id,
                    class: "p-10 lg:p-20"
                  }, null, 8, ["onChiudi", "id", "cliente_id"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 1)
                ? (_openBlock(), _createBlock(_component_FlagForm, {
                    key: 2,
                    onChiudi: _ctx.chiudi,
                    id: _ctx.id,
                    nota: _ctx.nota,
                    "onUpdate:nota": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:nota', $event))),
                    tags: _ctx.tags,
                    "onUpdate:tags": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:tags', $event))),
                    onSave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('manualSave'))),
                    class: "p-5",
                    "onUpdate:waiting": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:waiting', $event))),
                    waiting: _ctx.$attrs.waiting
                  }, null, 8, ["onChiudi", "id", "nota", "tags", "waiting"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 8)
                ? (_openBlock(), _createBlock(_component_InfoPolicy, {
                    key: 3,
                    onChiudi: _ctx.chiudi,
                    infoPolicy: _ctx.infoPolicy,
                    dataOfferta: _ctx.dataOfferta,
                    terminiPagamento: _ctx.terminiPagamento,
                    "onUpdate:infoPolicy": _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('update:infoPolicy', $event))),
                    "onUpdate:dataOfferta": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:dataOfferta', $event))),
                    "onUpdate:terminiPagamento": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:terminiPagamento', $event))),
                    onSave: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('savePolicy'))),
                    class: "p-5",
                    "onUpdate:waiting": _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('update:waiting', $event))),
                    waiting: _ctx.$attrs.waiting
                  }, null, 8, ["onChiudi", "infoPolicy", "dataOfferta", "terminiPagamento", "waiting"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 9)
                ? (_openBlock(), _createBlock(_component_Sconto, {
                    key: 4,
                    onChiudi: _ctx.chiudi,
                    sconto: _ctx.sconto,
                    "onUpdate:sconto": _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('update:sconto', $event))),
                    onSave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('saveSconto'))),
                    class: "p-5",
                    "onUpdate:waiting": _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('update:waiting', $event))),
                    waiting: _ctx.$attrs.waiting
                  }, null, 8, ["onChiudi", "sconto", "waiting"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 7)
                ? (_openBlock(), _createBlock(_component_ImportaSottoprogetto, {
                    key: 5,
                    onChiudi: _ctx.chiudi,
                    onSave: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('import', $event))),
                    class: "p-5",
                    waiting: _ctx.$attrs.waiting
                  }, null, 8, ["onChiudi", "waiting"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 2)
                ? (_openBlock(), _createBlock(_component_EsportaSottoprogetto, {
                    key: 6,
                    id: _ctx.id,
                    titolo: _ctx.sottoprogetto,
                    class: "p-10 lg:px-28 lg:py-16 lg:min-w-[610px]",
                    onChiudi: _ctx.chiudi
                  }, null, 8, ["id", "titolo", "onChiudi"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 3)
                ? (_openBlock(), _createBlock(_component_FeeRebateForm, {
                    key: 7,
                    fee: _ctx.fee,
                    sections: _ctx.sections.map((s, idx)=>{return {id:idx, titolo:s.titolo}}),
                    "onUpdate:fee": _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('update:fee',$event))),
                    onApplica_mark_up_a_tutti: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('applica_mark_up_a_tutti', $event))),
                    rebate: _ctx.rebate,
                    "onUpdate:rebate": _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('update:rebate',$event))),
                    default_markup: _ctx.default_markup,
                    "onUpdate:default_markup": _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('update:default_markup',$event))),
                    onChiudi: _ctx.chiudi,
                    class: "p-10 lg:p-20"
                  }, null, 8, ["fee", "sections", "rebate", "default_markup", "onChiudi"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 4)
                ? (_openBlock(), _createBlock(_component_CambioValutaForm, {
                    key: 8,
                    "onUpdate:valute": _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('update:valute',$event))),
                    valute: _ctx.valute,
                    onChiudi: _ctx.chiudi,
                    class: "p-10 lg:p-20"
                  }, null, 8, ["valute", "onChiudi"]))
                : _createCommentVNode("", true),
              (_ctx.tabindex === 6)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "" }, [
                      _createElementVNode("p", { class: "font-bold mb-3" }, "Storico vendite"),
                      _createElementVNode("p", { class: "mb-3" }, "Voui copiare i valori delle celle \"Budget Imponibile\" sulle celle \"Storico vendite\" laddove vuote?")
                    ], -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_NextButton, {
                        variant: "outline-secondary",
                        onClick: _ctx.chiudi,
                        class: "col-start-4 col-span-3 py-2 px-4"
                      }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode(" Chiudi ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_NextButton, {
                        variant: "primary",
                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('copiaStoricoVendite'))),
                        class: "col-span-3 ml-4 py-2 px-4"
                      }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode(" Sì ")
                        ])),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ], 32))
    : _createCommentVNode("", true)
}